import { MultiSelect } from 'components/common/Select/MultiSelect';
import { useIsSupplierPortalProductEditorFieldDisabled } from 'hooks/useUserState_utils';
import { countries } from 'helpers/countries';
import { useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const CountryOriginField = () => {
  const { t } = useTranslation();
  const { field } = useController({
    name: 'private_attributes.data.countryOrigin'
  });
  const disabled = useIsSupplierPortalProductEditorFieldDisabled();

  return (
    <MultiSelect
      label={t('forms.product.countryOrigin.label')}
      options={countries}
      placeholder="Start typing or click to select regions"
      onChange={field.onChange}
      value={field.value}
      disabled={disabled}
    />
  );
};
